<template>
  <div class="alert_class d-flex justify-content-center" :style="{marginBottom: '20px', padding: '10px 5px', backgroundColor: Theme['gray-200'], borderRadius: '8px'}">
    <span class="badge badge-circle me-5" :style="{backgroundColor: Theme.gray}">
      <i class="fas fa-info" style="color: #fff; font-size: 10px;"></i>
    </span>
    <span class="mt-1"> {{ text }}</span>
  </div>

</template>

<script setup>

import { defineProps } from 'vue'
import {Theme} from "@/composables/theming"

const props = defineProps({
  text: String
})

</script>
